import React from 'react';
import { FiHeadphones, FiLock, FiTrendingUp, FiZap } from 'react-icons/fi';
import './FeaturesSection.css';

const features = [
  {
    icon: FiZap,
    title: 'Fibra óptica pura',
    text: 'Mais estabilidade para trabalhar, estudar, jogar e assistir sem travamentos.',
  },
  {
    icon: FiTrendingUp,
    title: 'Alta performance',
    text: 'Planos pensados para múltiplas telas, downloads pesados e streaming em 4K.',
  },
  {
    icon: FiLock,
    title: 'Conexão segura',
    text: 'Infraestrutura moderna para navegar com mais tranquilidade no dia a dia.',
  },
  {
    icon: FiHeadphones,
    title: 'Suporte local',
    text: 'Atendimento próximo, ágil e pronto para resolver quando você precisar.',
  },
];

function FeaturesSection() {
  return (
    <section className="features-section">
      <div className="features-header">
        <span>Por que escolher a VitaLink</span>
        <h2>Internet premium de verdade, sem complicar sua vida</h2>
        <p>
          Você contrata uma rede preparada para a rotina real: reuniões, aulas,
          games, filmes, smart TVs e todos os dispositivos conectados ao mesmo tempo.
        </p>
      </div>

      <div className="features-container">
        {features.map(({ icon: Icon, title, text }) => (
          <article className="feature-item" key={title}>
            <div className="feature-icon">
              <Icon />
            </div>
            <h3>{title}</h3>
            <p>{text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default FeaturesSection;
